export default class MainNav {
    constructor() {
        this.mainNav = null;
        this.burger = null;
        this.classList = {
            mainNavClass: 'js-main-nav',
            burgerClass: 'js-nav-burger',
        };

        this.init();
    }

    init() {
        const { burgerClass, mainNavClass } = this.classList;

        this.mainNav = document.querySelector(`.${mainNavClass}`);
        this.burger = document.querySelector(`.${burgerClass}`);

        if (this.mainNav && this.burger) {
           this.initEvents();
        }
    }

    initEvents() {
        this.burger.addEventListener('click', this.openBurgerMenu.bind(this));
    }

    openBurgerMenu() {
        this.mainNav.classList.toggle('is-mobile-opened');
    }
}
